module.exports = __webpack_public_path__ + "static/media/gifSweetAlert.dfe11e3d.gif";